
// ─── Vận Hành CN — Trạm Bơm Tăng Áp ─────────────────────

const PUMP_PARAMS = {
  pressure: { set: 5.500, actual: 65.512, unit:"Bar", alarm:true  },
  bangVar:  { val:"—",    unit:"",        alarm:false },
  van1:     { val:"Mở",   unit:"",        alarm:false, open:true  },
}

const PUMPS_DATA = [
  { id:"BM-01", label:"Bơm 1", rpm:0,    current:0, setRpm:1450, status:"chưa sẵn sàng", active:false, alarm:false, color:"#2563eb" },
  { id:"BM-02", label:"Bơm 2", rpm:0,    current:0, setRpm:1450, status:"chưa sẵn sàng", active:false, alarm:false, color:"#2563eb" },
  { id:"BM-03", label:"Bơm 3", rpm:1450, current:8.2, setRpm:1450, status:"đang chạy",  active:true,  alarm:false, color:"#22c55e" },
]

const PUMP_ZONES = [
  { id:"Z1", label:"Khu vực F1–F4",  flow:927.0,  setFlow:927.0,  pressure:5.2,  tempIn:28, tempOut:34, active:true,  alarm:false, color:"#22c55e" },
  { id:"Z2", label:"Khu vực F5–F8",  flow:711.6,  setFlow:711.0,  pressure:5.1,  tempIn:28, tempOut:37, active:true,  alarm:false, color:"#f59e0b" },
  { id:"Z3", label:"Khu vực F9–F12", flow:163.9,  setFlow:164.0,  pressure:5.0,  tempIn:28, tempOut:41, active:true,  alarm:true,  color:"#ef4444" },
  { id:"Z4", label:"Cán thô JZ–FS",  flow:0,      setFlow:0,      pressure:0,    tempIn:28, tempOut:28, active:false, alarm:false, color:"#94a3b8" },
]

const PUMP_OUTPUTS = [
  { id:"OUT-W1", label:"Nước bơm ra cán",    icon:"💧", flow:1803, unit:"L/min", color:"#0ea5e9", active:true  },
  { id:"OUT-W2", label:"Nước hồi về bể",     icon:"🔄", flow:1798, unit:"L/min", color:"#22c55e", active:true  },
  { id:"OUT-DR", label:"Lưu lượng drain",    icon:"⬇",  flow:5,    unit:"L/min", color:"#94a3b8", active:true  },
  { id:"OUT-AL", label:"Cảnh báo cạn nước",  icon:"⚠",  flow:null, unit:"",      color:"#ef4444", active:false },
]

function VanHanhCNView() {
  const [selItem,  setSelItem]  = useState(null)
  const [hovId,    setHovId]    = useState(null)
  const [pumpMode, setPumpMode] = useState("tu-dong")  // "tu-dong"|"thu-cong"

  const alarmsN = PUMPS_DATA.filter(p=>p.alarm).length + PUMP_ZONES.filter(z=>z.alarm).length
  const activeP = PUMPS_DATA.filter(p=>p.active).length

  const HPipe = ({color="#22c55e",active=true,width=28,flow=null,unit=""}) => (
    <div style={{display:"flex",flexDirection:"column",alignItems:"center",gap:1,flexShrink:0}}>
      <div style={{width,height:3,background:active?color:"#e2e8f0",borderRadius:2,
        opacity:active?1:0.5,boxShadow:active?`0 0 4px ${color}66`:"none",transition:"all .2s"}}/>
      {flow!=null&&<span style={{fontSize:7,color:active?color:"#94a3b8",fontWeight:600,whiteSpace:"nowrap"}}>
        {flow>0?`+${flow}`:flow} {unit}</span>}
    </div>
  )
  const Arrow = ({color="#22c55e",active=true,dir="right"}) => (
    <span style={{fontSize:10,color:active?color:"#e2e8f0",flexShrink:0,lineHeight:1,
      filter:active?`drop-shadow(0 0 2px ${color}88)`:"none"}}>
      {dir==="right"?"▶":"◀"}</span>
  )
  const ColHeader = ({title,count=null,extra=null}) => (
    <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:12}}>
      <span style={{fontSize:11,fontWeight:700,color:"#64748b",letterSpacing:1,textTransform:"uppercase"}}>
        {title}{count!=null&&<span style={{fontWeight:400,fontSize:10,color:"#94a3b8"}}> ({count})</span>}
      </span>
      {extra||<div/>}
    </div>
  )

  // ── Pump card — MachineCard pattern ──
  const PumpCard = ({p}) => {
    const isSel = selItem?.data?.id===p.id
    const isHov = hovId===p.id
    const pct   = p.active ? Math.min((p.rpm/p.setRpm)*100,100) : 0
    return (
      <div
        onClick={()=>setSelItem(isSel?null:{type:"pump",data:p})}
        onMouseEnter={()=>setHovId(p.id)}
        onMouseLeave={()=>setHovId(null)}
        style={{
          background:"white",
          border:`2px solid ${isSel?"#2563eb":p.alarm?"#fca5a5":"#e2e8f0"}`,
          borderRadius:8,padding:"12px",cursor:"pointer",marginBottom:8,
          boxShadow:isSel?"0 0 0 3px rgba(37,99,235,.15)":isHov?"0 2px 8px rgba(0,0,0,0.08)":"none",
          transition:"all .15s",opacity:p.active?1:0.7
        }}>
        <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:10}}>
          <div style={{width:34,height:34,borderRadius:6,
            background:p.active?"#eff6ff":"#f1f5f9",
            display:"flex",alignItems:"center",justifyContent:"center",
            fontSize:18,flexShrink:0}}>
            {p.active?"💧":"○"}
          </div>
          <div style={{flex:1}}>
            <div style={{fontSize:11,fontWeight:700,color:"#374151"}}>{p.label}</div>
            <div style={{fontSize:9,fontFamily:"monospace",color:"#94a3b8"}}>{p.id}</div>
          </div>
          <span style={{fontSize:9,fontWeight:600,padding:"1px 6px",borderRadius:8,
            background:p.active?"#dcfce7":"#fee2e2",
            color:p.active?"#16a34a":"#dc2626"}}>
            {p.active?"Đang chạy":"Dừng"}</span>
        </div>
        {/* RPM + current */}
        <div style={{display:"flex",gap:10,marginBottom:8}}>
          <div style={{flex:1}}>
            <div style={{fontSize:9,color:"#94a3b8",marginBottom:1}}>Tốc độ</div>
            <div style={{fontSize:20,fontWeight:900,color:p.active?p.color:"#94a3b8",
              lineHeight:1,fontFamily:"monospace"}}>
              {p.rpm}<span style={{fontSize:9,fontWeight:400,color:"#94a3b8",marginLeft:2}}>rpm</span>
            </div>
          </div>
          <div style={{flex:1}}>
            <div style={{fontSize:9,color:"#94a3b8",marginBottom:1}}>Dòng điện</div>
            <div style={{fontSize:14,fontWeight:700,color:"#f59e0b",lineHeight:1,fontFamily:"monospace"}}>
              {p.current}<span style={{fontSize:9,fontWeight:400,color:"#94a3b8",marginLeft:2}}>A</span>
            </div>
          </div>
        </div>
        {/* Progress bar */}
        <div style={{height:5,background:"#f1f5f9",borderRadius:3,overflow:"hidden"}}>
          <div style={{height:"100%",borderRadius:3,transition:"width .3s",
            width:`${pct}%`,background:p.active?p.color:"#e2e8f0"}}/>
        </div>
      </div>
    )
  }

  // ── Zone card — InputCard pattern ──
  const ZoneCard = ({z}) => {
    const isSel = selItem?.data?.id===z.id
    const isHov = hovId===z.id
    return (
      <div
        onClick={()=>setSelItem(isSel?null:{type:"zone",data:z})}
        onMouseEnter={()=>setHovId(z.id)}
        onMouseLeave={()=>setHovId(null)}
        style={{
          background:"white",border:`2px solid ${isSel?"#2563eb":z.alarm?"#fca5a5":"#e2e8f0"}`,
          borderRadius:8,padding:"10px 12px",cursor:"pointer",marginBottom:8,
          boxShadow:isSel?"0 0 0 3px rgba(37,99,235,.15)":isHov?"0 2px 8px rgba(0,0,0,0.08)":"none",
          transition:"all .15s",opacity:z.active?1:0.55
        }}>
        <div style={{display:"flex",alignItems:"center",gap:6,marginBottom:6}}>
          <span style={{fontSize:14}}>🔧</span>
          <div style={{flex:1}}>
            <div style={{fontSize:11,fontWeight:700,color:"#374151"}}>{z.label}</div>
            <div style={{fontSize:9,fontFamily:"monospace",color:"#94a3b8"}}>{z.id}</div>
          </div>
          <span style={{fontSize:9,fontWeight:600,padding:"1px 6px",borderRadius:8,
            background:z.alarm?"#fee2e2":z.active?"#dcfce7":"#f1f5f9",
            color:z.alarm?"#dc2626":z.active?"#16a34a":"#64748b"}}>
            {z.alarm?"Cảnh báo":z.active?"Đang chạy":"Dừng"}</span>
        </div>
        {/* Flow row — FlowCard pattern */}
        <div style={{display:"flex",alignItems:"center",gap:4,marginBottom:4}}>
          <div style={{width:12,height:3,background:z.active?z.color:"#e2e8f0",borderRadius:2}}/>
          <svg viewBox="0 0 28 18" style={{width:28,height:18,flexShrink:0}}>
            <rect x={1} y={2} width={12} height={14} rx={2} fill="white"
              stroke={z.active?z.color:"#e2e8f0"} strokeWidth={1.5}/>
            <circle cx={7} cy={9} r={3} fill={z.active?z.color:"#e2e8f0"} opacity={0.25}/>
            <circle cx={7} cy={9} r={1.5} fill={z.active?z.color:"#e2e8f0"}/>
            <line x1={13} y1={9} x2={18} y2={9} stroke={z.active?z.color:"#e2e8f0"} strokeWidth={1.5}/>
            <rect x={18} y={2} width={9} height={14} rx={2} fill="white"
              stroke={z.active?z.color:"#e2e8f0"} strokeWidth={1.5}/>
          </svg>
          <div style={{width:6,height:3,background:z.active?z.color:"#e2e8f0",borderRadius:2}}/>
          <Arrow color={z.color} active={z.active} dir="right"/>
          <div style={{flex:1,textAlign:"right"}}>
            <span style={{fontSize:14,fontWeight:800,color:z.active?z.color:"#94a3b8",
              fontFamily:"monospace"}}>{z.flow}</span>
            <span style={{fontSize:9,color:"#94a3b8",marginLeft:2}}>L/min</span>
          </div>
        </div>
        {/* Temp delta */}
        <div style={{display:"flex",justifyContent:"space-between",fontSize:9,color:"#64748b"}}>
          <span>Áp suất: <span style={{fontWeight:700,color:"#2563eb",fontFamily:"monospace"}}>{z.pressure} Bar</span></span>
          <span>ΔT: <span style={{fontWeight:700,color:z.tempOut>40?"#ef4444":"#374151",
            fontFamily:"monospace"}}>{z.tempIn}→{z.tempOut}°C</span></span>
        </div>
      </div>
    )
  }

  // ── Output card — OutputCard pattern ──
  const OutputCard = ({item}) => {
    const isSel = selItem?.data?.id===item.id
    const isHov = hovId===item.id
    return (
      <div
        onClick={()=>setSelItem(isSel?null:{type:"output",data:item})}
        onMouseEnter={()=>setHovId(item.id)}
        onMouseLeave={()=>setHovId(null)}
        style={{
          background:"white",border:`2px solid ${isSel?"#2563eb":item.active?"#e2e8f0":"#f1f5f9"}`,
          borderRadius:8,padding:"10px 12px",cursor:"pointer",marginBottom:8,
          boxShadow:isSel?"0 0 0 3px rgba(37,99,235,.15)":isHov?"0 2px 8px rgba(0,0,0,0.08)":"none",
          transition:"all .15s",opacity:item.active?1:0.55
        }}>
        <div style={{display:"flex",alignItems:"center",gap:6,marginBottom:6}}>
          <span style={{fontSize:16}}>{item.icon}</span>
          <div style={{flex:1}}>
            <div style={{fontSize:11,fontWeight:700,color:"#374151"}}>{item.label}</div>
            <div style={{fontSize:9,fontFamily:"monospace",color:"#94a3b8"}}>{item.id}</div>
          </div>
          {!item.active&&<span style={{fontSize:9,background:"#fee2e2",color:"#dc2626",
            padding:"1px 6px",borderRadius:8,fontWeight:600}}>Dừng</span>}
        </div>
        <div style={{display:"flex",alignItems:"center",gap:4}}>
          <Arrow color={item.color} active={item.active} dir="left"/>
          <div style={{width:6,height:3,background:item.active?item.color:"#e2e8f0",borderRadius:2}}/>
          <svg viewBox="0 0 28 18" style={{width:28,height:18,flexShrink:0}}>
            <rect x={1} y={2} width={12} height={14} rx={2} fill="white"
              stroke={item.active?item.color:"#e2e8f0"} strokeWidth={1.5}/>
            <circle cx={7} cy={9} r={3} fill={item.active?item.color:"#e2e8f0"} opacity={0.25}/>
            <circle cx={7} cy={9} r={1.5} fill={item.active?item.color:"#e2e8f0"}/>
            <line x1={13} y1={9} x2={18} y2={9} stroke={item.active?item.color:"#e2e8f0"} strokeWidth={1.5}/>
            <rect x={18} y={2} width={9} height={14} rx={2} fill="white"
              stroke={item.active?item.color:"#e2e8f0"} strokeWidth={1.5}/>
          </svg>
          <div style={{width:8,height:3,background:item.active?item.color:"#e2e8f0",borderRadius:2}}/>
          <div style={{flex:1,textAlign:"right"}}>
            {item.flow!=null
              ? <><span style={{fontSize:14,fontWeight:800,color:item.active?item.color:"#94a3b8",
                  fontFamily:"monospace"}}>{item.flow}</span>
                <span style={{fontSize:9,color:"#94a3b8",marginLeft:2}}>{item.unit}</span></>
              : <span style={{fontSize:9,color:"#94a3b8"}}>Bình thường</span>
            }
          </div>
        </div>
      </div>
    )
  }

  // ── Detail panel ──
  const DetailPanel = () => {
    if (!selItem) return (
      <div style={{height:"100%",display:"flex",flexDirection:"column",
        alignItems:"center",justifyContent:"center",
        color:"#94a3b8",fontSize:12,padding:20,textAlign:"center",gap:8}}>
        <span style={{fontSize:32}}>💧</span>
        <span style={{fontWeight:600,color:"#64748b"}}>Chọn phần tử</span>
        <span style={{fontSize:11,color:"#cbd5e1",lineHeight:1.5}}>
          Nhấp vào bơm, vùng tưới hoặc đầu ra để xem chi tiết
        </span>
      </div>
    )
    const item  = selItem.data
    const color = item.color||"#2563eb"
    const trend = Array.from({length:18},(_,i)=>
      item.active ? 30+Math.abs(Math.sin(i/3))*50+(Math.random()-.5)*8 : 5
    )
    const fields = selItem.type==="pump" ? [
      ["Tốc độ TT",    `${item.rpm} rpm`],
      ["Cài đặt",      `${item.setRpm} rpm`],
      ["Dòng điện",    `${item.current} A`],
      ["Trạng thái",   item.active?"Đang chạy":"Dừng"],
    ] : selItem.type==="zone" ? [
      ["Lưu lượng",    `${item.flow} L/min`],
      ["Cài đặt",      `${item.setFlow} L/min`],
      ["Áp suất",      `${item.pressure} Bar`],
      ["T° vào/ra",    `${item.tempIn}°→${item.tempOut}°C`],
      ["Trạng thái",   item.alarm?"Cảnh báo":item.active?"Đang chạy":"Dừng"],
    ] : [
      ["Lưu lượng",    item.flow!=null?`${item.flow} ${item.unit}`:"—"],
      ["Trạng thái",   item.active?"Hoạt động":"Dừng"],
    ]
    return (
      <div>
        <div style={{padding:"10px 14px",background:"#f8fafc",borderBottom:"1px solid #e2e8f0",
          display:"flex",alignItems:"center",justifyContent:"space-between"}}>
          <div>
            <span style={{fontSize:9,color:"#94a3b8",fontFamily:"monospace"}}>{item.id} · </span>
            <span style={{fontSize:12,fontWeight:700,color:"#0f172a"}}>{item.label}</span>
          </div>
          <button style={{background:"none",border:"none",cursor:"pointer",color:"#94a3b8",fontSize:16}}>⋯</button>
        </div>
        <div style={{display:"flex",borderBottom:"1px solid #f1f5f9"}}>
          {["Thông tin","Lịch sử"].map((t,i)=>(
            <button key={t} style={{padding:"8px 12px",border:"none",cursor:"pointer",fontSize:11,
              fontWeight:i===0?700:400,color:i===0?"#2563eb":"#94a3b8",
              borderBottom:i===0?"2px solid #2563eb":"2px solid transparent",
              background:"none"}}>{t}</button>
          ))}
        </div>
        <div style={{padding:"14px",background:"white",borderBottom:"1px solid #f1f5f9",textAlign:"center"}}>
          <div style={{fontSize:28,fontWeight:900,fontFamily:"monospace",color:item.active?color:"#94a3b8",lineHeight:1}}>
            {selItem.type==="pump"?item.rpm:selItem.type==="zone"?item.flow:item.flow??<span style={{fontSize:14}}>OK</span>}
          </div>
          <div style={{fontSize:10,color:"#94a3b8",marginTop:4}}>
            {selItem.type==="pump"?"rpm":selItem.type==="zone"?"L/min":item.unit}
          </div>
        </div>
        {fields.map(([k,v])=>(
          <div key={k} style={{display:"flex",justifyContent:"space-between",padding:"7px 14px",borderBottom:"1px solid #f8fafc"}}>
            <span style={{fontSize:11,color:"#94a3b8"}}>{k}</span>
            <span style={{fontSize:11,fontWeight:600,
              color:k==="Trạng thái"&&(v==="Dừng"||v==="Cảnh báo")?"#dc2626":
                    k==="Trạng thái"?"#16a34a":"#0f172a"}}>{v}</span>
          </div>
        ))}
        <div style={{padding:"8px 14px 2px",fontSize:9,fontWeight:700,
          color:"#94a3b8",letterSpacing:1,background:"#f8fafc",marginTop:4}}>GIỜ VỪA QUA</div>
        <div style={{padding:"6px 14px 14px",background:"#f8fafc"}}>
          <div style={{display:"flex",alignItems:"flex-end",gap:1,height:44}}>
            {trend.map((v,i)=>(
              <div key={i} style={{flex:1,height:`${v}%`,background:color,
                borderRadius:"1px 1px 0 0",opacity:0.8}}/>
            ))}
          </div>
          <div style={{display:"flex",justifyContent:"space-between",marginTop:2}}>
            <span style={{fontSize:7,color:"#94a3b8"}}>-1h</span>
            <span style={{fontSize:7,color:"#94a3b8"}}>hiện tại</span>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div style={{flex:1,display:"flex",overflow:"hidden"}}>
      <div style={{flex:1,overflow:"auto",padding:"14px 16px"}}>

        {/* KPI strip */}
        <div style={{display:"flex",gap:8,marginBottom:14,flexWrap:"wrap"}}>
          {[
            {label:"Bơm đang chạy",   value:`${activeP}/${PUMPS_DATA.length}`, icon:"💧", color:"#2563eb"},
            {label:"Áp suất đặt",     value:"5.500 Bar",  icon:"📊", color:"#2563eb"},
            {label:"Áp suất thực",    value:"65.512",     icon:"⚡",  color:"#ef4444", alarm:true},
            {label:"Tổng lưu lượng",  value:"1 803 L/min",icon:"🌊", color:"#0ea5e9"},
            {label:"Cảnh báo",        value:`${alarmsN}`, icon:"⚠",  color:alarmsN>0?"#ef4444":"#22c55e"},
          ].map(k=>(
            <div key={k.label} style={{
              background:"white",border:`1px solid ${k.alarm?"#fca5a5":"#e2e8f0"}`,borderRadius:8,
              padding:"8px 12px",display:"flex",alignItems:"center",gap:8,
              flex:1,minWidth:100,boxShadow:k.alarm?"0 0 0 3px rgba(239,68,68,.06)":"0 1px 3px rgba(0,0,0,0.04)"
            }}>
              <span style={{fontSize:18}}>{k.icon}</span>
              <div>
                <div style={{fontSize:14,fontWeight:800,color:k.color,lineHeight:1}}>{k.value}</div>
                <div style={{fontSize:9,color:"#94a3b8",marginTop:1}}>{k.label}</div>
              </div>
            </div>
          ))}
        </div>

        {/* Mode selector */}
        <div style={{
          background:"white",border:"1px solid #e2e8f0",borderRadius:8,
          padding:"8px 14px",marginBottom:10,
          display:"flex",alignItems:"center",gap:8,
          boxShadow:"0 1px 3px rgba(0,0,0,0.04)"
        }}>
          <span style={{fontSize:10,fontWeight:700,color:"#64748b",
            letterSpacing:1,textTransform:"uppercase"}}>Chế độ vận hành</span>
          <div style={{display:"flex",gap:4}}>
            {[{id:"tu-dong",label:"Tự động"},{id:"thu-cong",label:"Thủ công"}].map(m=>(
              <button key={m.id} onClick={()=>setPumpMode(m.id)} style={{
                padding:"4px 12px",border:"none",borderRadius:5,cursor:"pointer",
                fontSize:10,fontWeight:600,
                background:pumpMode===m.id?"#1e3a5f":"#f1f5f9",
                color:pumpMode===m.id?"white":"#64748b"
              }}>{m.label}</button>
            ))}
          </div>
          <div style={{flex:1}}/>
          {/* Pressure params inline */}
          <div style={{
            display:"flex",gap:10,alignItems:"center",
            background:"#f8fafc",border:"1px solid #e2e8f0",
            borderRadius:6,padding:"4px 10px"
          }}>
            <div style={{fontSize:9,color:"#94a3b8"}}>Áp đặt</div>
            <div style={{fontSize:13,fontWeight:800,color:"#2563eb",fontFamily:"monospace"}}>
              {PUMP_PARAMS.pressure.set} Bar
            </div>
            <div style={{width:1,height:14,background:"#e2e8f0"}}/>
            <div style={{fontSize:9,color:"#94a3b8"}}>Áp thực</div>
            <div style={{
              fontSize:13,fontWeight:800,color:"#ef4444",fontFamily:"monospace",
              background:"#fee2e2",padding:"1px 5px",borderRadius:3
            }}>
              {PUMP_PARAMS.pressure.actual}
            </div>
          </div>
        </div>

        {/* 3-column layout */}
        <div style={{display:"flex",gap:0,minWidth:560}}>

          {/* COL 1: Bơm */}
          <div style={{flex:1,borderRight:"1px solid #e2e8f0",paddingRight:12,minWidth:170}}>
            <ColHeader title="Tổ bơm" count={PUMPS_DATA.length} extra={
              <div style={{display:"flex",gap:4}}>
                <HPipe color="#0ea5e9" active={true} width={20}/>
                <Arrow color="#0ea5e9" active={true} dir="right"/>
              </div>
            }/>
            {PUMPS_DATA.map(p=><PumpCard key={p.id} p={p}/>)}

            {/* Van 1 status */}
            <div style={{
              background:"white",border:"1px solid #e2e8f0",borderRadius:8,
              padding:"10px 12px",boxShadow:"0 1px 3px rgba(0,0,0,0.04)"
            }}>
              <div style={{fontSize:10,fontWeight:700,color:"#374151",marginBottom:6}}>Van & Phụ Trợ</div>
              {[
                {k:"Van 1",      v:"Mở",        c:"#22c55e"},
                {k:"Bằng Var",   v:"—",          c:"#94a3b8"},
                {k:"Chế độ",    v:"Tự Động",    c:"#2563eb"},
              ].map(r=>(
                <div key={r.k} style={{display:"flex",justifyContent:"space-between",
                  padding:"4px 0",borderBottom:"1px solid #f8fafc"}}>
                  <span style={{fontSize:9,color:"#94a3b8"}}>{r.k}</span>
                  <span style={{fontSize:10,fontWeight:700,color:r.c}}>{r.v}</span>
                </div>
              ))}
            </div>
          </div>

          {/* COL 2: Vùng tưới */}
          <div style={{flex:1.1,borderRight:"1px solid #e2e8f0",padding:"0 12px",minWidth:180}}>
            <ColHeader title="Vùng làm mát" count={PUMP_ZONES.length}/>
            {PUMP_ZONES.map(z=><ZoneCard key={z.id} z={z}/>)}
          </div>

          {/* COL 3: Đầu ra */}
          <div style={{flex:1,paddingLeft:12,minWidth:160}}>
            <div style={{display:"flex",alignItems:"center",marginBottom:12}}>
              <Arrow color="#0ea5e9" active={true} dir="left"/>
              <HPipe color="#0ea5e9" active={true} width={12}/>
              <div style={{flex:1}}><ColHeader title="Đầu ra" count={PUMP_OUTPUTS.length}/></div>
            </div>
            {PUMP_OUTPUTS.map(o=><OutputCard key={o.id} item={o}/>)}
          </div>

        </div>
      </div>

      {/* Right detail panel */}
      <div style={{
        width:268,background:"white",borderLeft:"1px solid #e2e8f0",
        flexShrink:0,overflowY:"auto"
      }}>
        <DetailPanel/>
      </div>
    </div>
  )
}


// ─── Dây Chuyền Cán Thép ──────────────────────────────────

// ── Rolling stands data (F1–F12 + roughing JZ, FS) ──
const CT_STANDS = [
  { id:"JZ",   label:"JZ",   group:"rough",  rpm:808.0, setRpm:808.0, load:72, loadSet:100, current:null, water:0.0,  waterSet:0.0,  active:true,  alarm:false, color:"#2563eb" },
  { id:"FS",   label:"FS",   group:"rough",  rpm:797.0, setRpm:797.0, load:68, loadSet:100, current:null, water:0.0,  waterSet:0.0,  active:true,  alarm:false, color:"#2563eb" },
  { id:"F1",   label:"F1",   group:"finish", rpm:60.0,  setRpm:60.0,  load:45, loadSet:100, current:1.00, water:927.0,waterSet:927.0,active:true,  alarm:false, color:"#22c55e" },
  { id:"F2",   label:"F2",   group:"finish", rpm:60.0,  setRpm:60.0,  load:53, loadSet:100, current:0.90, water:927.0,waterSet:927.0,active:true,  alarm:false, color:"#22c55e" },
  { id:"F3",   label:"F3",   group:"finish", rpm:60.0,  setRpm:60.0,  load:48, loadSet:100, current:0.80, water:1001.0,waterSet:1000.0,active:true, alarm:false, color:"#22c55e" },
  { id:"F4",   label:"F4",   group:"finish", rpm:60.0,  setRpm:60.0,  load:50, loadSet:100, current:0.87, water:1001.0,waterSet:1000.0,active:true, alarm:false, color:"#22c55e" },
  { id:"F5",   label:"F5",   group:"finish", rpm:60.0,  setRpm:60.0,  load:52, loadSet:100, current:0.97, water:711.6,waterSet:711.0,active:true,  alarm:false, color:"#f59e0b" },
  { id:"F6",   label:"F6",   group:"finish", rpm:60.0,  setRpm:60.0,  load:55, loadSet:100, current:1.00, water:711.6,waterSet:711.0,active:true,  alarm:false, color:"#f59e0b" },
  { id:"F7",   label:"F7",   group:"finish", rpm:4.38,  setRpm:4.38,  load:79, loadSet:100, current:0.55, water:572.3,waterSet:572.0,active:true,  alarm:false, color:"#ef4444" },
  { id:"F8",   label:"F8",   group:"finish", rpm:4.85,  setRpm:4.85,  load:83, loadSet:100, current:0.61, water:572.3,waterSet:572.0,active:true,  alarm:false, color:"#ef4444" },
  { id:"F9",   label:"F9",   group:"finish", rpm:5.28,  setRpm:5.28,  load:88, loadSet:100, current:0.78, water:186.5,waterSet:186.0,active:true,  alarm:false, color:"#a855f7" },
  { id:"F10",  label:"F10",  group:"finish", rpm:5.92,  setRpm:5.92,  load:91, loadSet:100, current:0.92, water:186.5,waterSet:186.0,active:true,  alarm:true,  color:"#a855f7" },
  { id:"F11",  label:"F11",  group:"finish", rpm:3.38,  setRpm:3.38,  load:85, loadSet:100, current:1.16, water:163.9,waterSet:164.0,active:true,  alarm:false, color:"#0ea5e9" },
  { id:"F12",  label:"F12",  group:"finish", rpm:3.98,  setRpm:3.38,  load:82, loadSet:100, current:1.13, water:163.9,waterSet:164.0,active:true,  alarm:false, color:"#0ea5e9" },
]

const CT_SYSTEM = {
  spinningRpm: { actual:808.0, set:808.0 },
  pitchRpm:    { actual:797.0, set:797.0 },
  xjzRH:   true,  xjzEstop: false,
  bjzRH:   true,  bjzEstop: false,
  zzRH:    true,  zzEstop:  false,
}

// generate deterministic-ish trend
function ctTrend(base, noise, n=40) {
  let v = base
  return Array.from({length:n},()=>{
    v = Math.max(base*0.6, Math.min(base*1.3, v + (Math.random()-.48)*noise))
    return +v.toFixed(2)
  })
}

const CT_TRENDS = CT_STANDS.map(s=>({
  id:s.id, color:s.color,
  rpmData:     ctTrend(s.rpm||10, (s.rpm||10)*0.06),
  loadData:    ctTrend(s.load,    s.load*0.08),
  currentData: ctTrend(s.current||0.5, 0.08),
}))

// ── Mini bar (load indicator) ──
function LoadBar({ pct=50, color="#22c55e", alarm=false, w=18, h=48 }) {
  const fillH = (pct/100)*h
  return (
    <svg viewBox={`0 0 ${w} ${h}`} style={{width:w,height:h,display:"block",flexShrink:0}}>
      <rect x={2} y={0} width={w-4} height={h} rx={2}
        fill="#f1f5f9" stroke="#e2e8f0" strokeWidth={1}/>
      <rect x={3} y={h-fillH} width={w-6} height={fillH} rx={1}
        fill={alarm?"#ef4444":pct>85?"#f59e0b":color} opacity={0.85}/>
      <text x={w/2} y={h-fillH-2} textAnchor="middle" fontSize={6}
        fontWeight="700" fill={pct>85?"#f59e0b":"#64748b"}>{pct}</text>
    </svg>
  )
}

// ── Multi-line trend SVG ──
function MultiTrendChart({ series, height=140 }) {
  const W = 580, H = height, PAD = {l:36,r:8,t:6,b:20}
  const IW = W-PAD.l-PAD.r, IH = H-PAD.t-PAD.b
  const N  = series[0]?.data?.length || 40

  const paths = series.map(s=>{
    const mn = Math.min(...s.data), mx = Math.max(...s.data)
    const range = mx-mn || 1
    const pts = s.data.map((v,i)=>{
      const x = PAD.l + (i/(N-1))*IW
      const y = PAD.t + IH - ((v-mn)/range)*IH
      return `${x.toFixed(1)},${y.toFixed(1)}`
    }).join(' ')
    return {...s, pts, mn, mx}
  })
  const times = ['11:05','11:08','11:11','11:14','11:17']
  return (
    <svg viewBox={`0 0 ${W} ${H}`} style={{width:"100%",height,display:"block"}}>
      {[0,.25,.5,.75,1].map((f,i)=>(
        <line key={i} x1={PAD.l} y1={PAD.t+IH*f} x2={PAD.l+IW} y2={PAD.t+IH*f}
          stroke="#f1f5f9" strokeWidth={1}/>
      ))}
      {paths.map(s=>(
        <polyline key={s.id} points={s.pts}
          fill="none" stroke={s.color} strokeWidth={1.5}
          strokeLinejoin="round" opacity={0.85}/>
      ))}
      <line x1={PAD.l} y1={PAD.t+IH} x2={PAD.l+IW} y2={PAD.t+IH}
        stroke="#e2e8f0" strokeWidth={1}/>
      <line x1={PAD.l} y1={PAD.t} x2={PAD.l} y2={PAD.t+IH}
        stroke="#e2e8f0" strokeWidth={1}/>
      {times.map((t,i)=>(
        <text key={t} x={PAD.l+(i/4)*IW} y={H-4}
          textAnchor="middle" fontSize={7} fill="#94a3b8">{t}</text>
      ))}
    </svg>
  )
}

function DayChuyenCanThepView() {
  const [selStand,  setSelStand]  = useState(null)
  const [hovId,     setHovId]     = useState(null)
  const [trendMode, setTrendMode] = useState("rpm")   // "rpm"|"load"|"current"
  const [running,   setRunning]   = useState(true)

  const alarmsN   = CT_STANDS.filter(s=>s.alarm).length
  const activeN   = CT_STANDS.filter(s=>s.active).length
  const avgLoad   = (CT_STANDS.reduce((a,s)=>a+s.load,0)/CT_STANDS.length).toFixed(0)

  // canonical helpers
  const HPipe = ({color="#22c55e",active=true,width=28}) => (
    <div style={{height:3,width,flexShrink:0,background:active?color:"#e2e8f0",
      borderRadius:2,boxShadow:active?`0 0 4px ${color}66`:"none"}}/>
  )
  const Arrow = ({color="#22c55e",active=true,dir="right"}) => (
    <span style={{fontSize:10,color:active?color:"#e2e8f0",flexShrink:0,lineHeight:1,
      filter:active?`drop-shadow(0 0 2px ${color}88)`:"none"}}>
      {dir==="right"?"▶":"◀"}</span>
  )

  // ── Stand card (used in detail panel) ──
  const StandCard = ({s}) => {
    const isSel = selStand?.id===s.id
    const isHov = hovId===s.id
    return (
      <div
        onClick={()=>setSelStand(isSel?null:s)}
        onMouseEnter={()=>setHovId(s.id)}
        onMouseLeave={()=>setHovId(null)}
        style={{
          background:"white",
          border:`2px solid ${isSel?"#2563eb":s.alarm?"#fca5a5":"#e2e8f0"}`,
          borderRadius:8,padding:"10px",cursor:"pointer",
          boxShadow:isSel?"0 0 0 3px rgba(37,99,235,.15)":isHov?"0 2px 8px rgba(0,0,0,0.08)":"none",
          transition:"all .15s",opacity:s.active?1:0.5
        }}>
        {/* Header */}
        <div style={{display:"flex",alignItems:"center",gap:6,marginBottom:6}}>
          <div style={{
            width:28,height:28,borderRadius:5,
            background:s.alarm?"#fef2f2":s.active?"#eff6ff":"#f1f5f9",
            display:"flex",alignItems:"center",justifyContent:"center",
            fontSize:13,fontWeight:900,color:s.alarm?"#ef4444":s.active?s.color:"#94a3b8",
            flexShrink:0
          }}>{s.label}</div>
          <div style={{flex:1}}>
            <div style={{fontSize:9,color:"#94a3b8",textTransform:"capitalize"}}>
              {s.group==="rough"?"Cán thô":"Cán tinh"}
            </div>
          </div>
          {s.alarm&&<span style={{width:14,height:14,borderRadius:"50%",background:"#ef4444",
            display:"inline-flex",alignItems:"center",justifyContent:"center",
            fontSize:7,color:"white",fontWeight:900}}>!</span>}
        </div>
        {/* Load bar */}
        <div style={{display:"flex",justifyContent:"center",marginBottom:6}}>
          <LoadBar pct={s.load} color={s.color} alarm={s.alarm} w={22} h={44}/>
        </div>
        {/* Speed */}
        <div style={{textAlign:"center"}}>
          <div style={{fontSize:13,fontWeight:900,color:s.active?s.color:"#94a3b8",
            fontFamily:"monospace",lineHeight:1}}>{s.rpm}</div>
          <div style={{fontSize:7,color:"#94a3b8",marginTop:1}}>rpm</div>
        </div>
      </div>
    )
  }

  // ── Detail panel ──
  const DetailPanel = () => {
    if (!selStand) return (
      <div style={{height:"100%",display:"flex",flexDirection:"column",
        alignItems:"center",justifyContent:"center",
        color:"#94a3b8",fontSize:12,padding:20,textAlign:"center",gap:8}}>
        <span style={{fontSize:32}}>⚙</span>
        <span style={{fontWeight:600,color:"#64748b"}}>Chọn giá cán</span>
        <span style={{fontSize:11,color:"#cbd5e1",lineHeight:1.5}}>
          Nhấp vào một giá cán để xem thông số
        </span>
      </div>
    )
    const s = selStand
    const t = CT_TRENDS.find(t=>t.id===s.id)
    const trendData = trendMode==="rpm"?t.rpmData:trendMode==="load"?t.loadData:t.currentData
    const trendColor = trendMode==="rpm"?s.color:trendMode==="load"?"#f59e0b":"#0ea5e9"
    return (
      <div>
        <div style={{padding:"10px 14px",background:"#f8fafc",borderBottom:"1px solid #e2e8f0",
          display:"flex",alignItems:"center",justifyContent:"space-between"}}>
          <div>
            <span style={{fontSize:9,color:"#94a3b8",fontFamily:"monospace"}}>{s.id} · </span>
            <span style={{fontSize:13,fontWeight:700,color:"#0f172a"}}>Giá cán {s.label}</span>
          </div>
          <span style={{fontSize:9,fontWeight:600,padding:"2px 7px",borderRadius:8,
            background:s.alarm?"#fee2e2":s.active?"#dcfce7":"#f1f5f9",
            color:s.alarm?"#dc2626":s.active?"#16a34a":"#64748b"}}>
            {s.alarm?"Cảnh báo":s.active?"Đang cán":"Dừng"}</span>
        </div>
        <div style={{display:"flex",borderBottom:"1px solid #f1f5f9"}}>
          {["Thông tin","Cảnh báo"].map((t,i)=>(
            <button key={t} style={{padding:"8px 12px",border:"none",cursor:"pointer",fontSize:11,
              fontWeight:i===0?700:400,color:i===0?"#2563eb":"#94a3b8",
              borderBottom:i===0?"2px solid #2563eb":"2px solid transparent",
              background:"none"}}>{t}</button>
          ))}
        </div>
        {/* Big value */}
        <div style={{padding:"12px 14px",background:"white",borderBottom:"1px solid #f1f5f9"}}>
          <div style={{display:"flex",gap:12,alignItems:"flex-start"}}>
            <LoadBar pct={s.load} color={s.color} alarm={s.alarm} w={28} h={60}/>
            <div>
              <div style={{fontSize:22,fontWeight:900,color:s.active?s.color:"#94a3b8",
                fontFamily:"monospace",lineHeight:1}}>
                {s.rpm}
                <span style={{fontSize:10,fontWeight:400,color:"#94a3b8",marginLeft:3}}>rpm</span>
              </div>
              <div style={{fontSize:12,fontWeight:700,color:"#f59e0b",marginTop:4,fontFamily:"monospace"}}>
                {s.load}%
                <span style={{fontSize:9,fontWeight:400,color:"#94a3b8",marginLeft:3}}>charge</span>
              </div>
              {s.current&&<div style={{fontSize:11,color:"#0ea5e9",fontFamily:"monospace",marginTop:3}}>
                {s.current} <span style={{fontSize:9,color:"#94a3b8"}}>A</span>
              </div>}
            </div>
          </div>
        </div>
        {[
          ["Tốc độ TT",    `${s.rpm} rpm`],
          ["Cài đặt",      `${s.setRpm} rpm`],
          ["Sai lệch",     `Δ ${Math.abs(s.rpm-s.setRpm).toFixed(2)} rpm`],
          ["Tải",          `${s.load}%`],
          ["Dòng điện",    s.current?`${s.current} A`:"—"],
          ["Nước làm mát", s.water?`${s.water} L/min`:"—"],
          ["Cài nước",     s.waterSet?`${s.waterSet} L/min`:"—"],
          ["Nhóm",         s.group==="rough"?"Cán thô":"Cán tinh"],
        ].map(([k,v])=>(
          <div key={k} style={{display:"flex",justifyContent:"space-between",
            padding:"5px 14px",borderBottom:"1px solid #f8fafc"}}>
            <span style={{fontSize:10,color:"#94a3b8"}}>{k}</span>
            <span style={{fontSize:10,fontWeight:600,color:"#0f172a"}}>{v}</span>
          </div>
        ))}
        {/* Trend selector */}
        <div style={{padding:"8px 14px 4px",display:"flex",gap:4}}>
          {["rpm","load","current"].map(m=>(
            <button key={m} onClick={()=>setTrendMode(m)} style={{
              flex:1,padding:"3px 0",border:"none",borderRadius:4,cursor:"pointer",
              fontSize:8,fontWeight:700,
              background:trendMode===m?trendColor:"#f1f5f9",
              color:trendMode===m?"white":"#94a3b8"
            }}>{m}</button>
          ))}
        </div>
        <div style={{padding:"4px 14px 12px",background:"#f8fafc"}}>
          <div style={{display:"flex",alignItems:"flex-end",gap:0.5,height:44}}>
            {trendData.map((v,i)=>{
              const mn = Math.min(...trendData), mx=Math.max(...trendData)
              const h = ((v-mn)/(mx-mn||1))*100
              return <div key={i} style={{flex:1,height:`${Math.max(5,h)}%`,
                background:trendColor,borderRadius:"1px 1px 0 0",opacity:0.8}}/>
            })}
          </div>
          <div style={{display:"flex",justifyContent:"space-between",marginTop:2}}>
            <span style={{fontSize:7,color:"#94a3b8"}}>-15min</span>
            <span style={{fontSize:7,color:"#94a3b8"}}>hiện tại</span>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div style={{flex:1,display:"flex",overflow:"hidden"}}>

      {/* ── Main canvas ── */}
      <div style={{flex:1,overflow:"auto",padding:"14px 16px"}}>

        {/* KPI strip */}
        <div style={{display:"flex",gap:8,marginBottom:14,flexWrap:"wrap"}}>
          {[
            {label:"Giá cán hoạt động", value:`${activeN}/${CT_STANDS.length}`, icon:"⚙", color:"#2563eb"},
            {label:"Spinning (JZ)",     value:`${CT_SYSTEM.spinningRpm.actual} rpm`, icon:"🔄", color:"#2563eb"},
            {label:"Pitch (FS)",        value:`${CT_SYSTEM.pitchRpm.actual} rpm`, icon:"⚡", color:"#2563eb"},
            {label:"Tải trung bình",    value:`${avgLoad}%`,  icon:"📊", color:"#f59e0b"},
            {label:"Cảnh báo",          value:`${alarmsN}`,  icon:"⚠",  color:alarmsN>0?"#ef4444":"#22c55e"},
          ].map(k=>(
            <div key={k.label} style={{
              background:"white",border:"1px solid #e2e8f0",borderRadius:8,
              padding:"8px 12px",display:"flex",alignItems:"center",gap:8,
              flex:1,minWidth:100,boxShadow:"0 1px 3px rgba(0,0,0,0.04)"
            }}>
              <span style={{fontSize:18}}>{k.icon}</span>
              <div>
                <div style={{fontSize:14,fontWeight:800,color:k.color,lineHeight:1}}>{k.value}</div>
                <div style={{fontSize:9,color:"#94a3b8",marginTop:1}}>{k.label}</div>
              </div>
            </div>
          ))}
        </div>

        {/* ── Control status bar ── */}
        <div style={{
          background:"white",border:"1px solid #e2e8f0",borderRadius:8,
          padding:"8px 14px",marginBottom:10,
          boxShadow:"0 1px 3px rgba(0,0,0,0.04)",
          display:"flex",alignItems:"center",gap:10,flexWrap:"wrap"
        }}>
          <span style={{fontSize:9,fontWeight:700,color:"#64748b",letterSpacing:1,textTransform:"uppercase"}}>
            Trạng Thái Điều Khiển
          </span>
          {[
            {id:"XJZ-RH",  on:CT_SYSTEM.xjzRH,   c:"#22c55e"},
            {id:"XJZ-Estop",on:CT_SYSTEM.xjzEstop,c:"#ef4444"},
            {id:"BJZ-RH",  on:CT_SYSTEM.bjzRH,   c:"#22c55e"},
            {id:"BJZ-Estop",on:CT_SYSTEM.bjzEstop,c:"#ef4444"},
            {id:"ZZ-RH",   on:CT_SYSTEM.zzRH,    c:"#22c55e"},
            {id:"ZZ-Estop", on:CT_SYSTEM.zzEstop, c:"#ef4444"},
          ].map(s=>(
            <div key={s.id} style={{
              display:"flex",alignItems:"center",gap:5,
              background:s.on?"#f0fdf4":"#fef2f2",
              border:`1px solid ${s.on?"#bbf7d0":"#fca5a5"}`,
              borderRadius:6,padding:"3px 8px"
            }}>
              <div style={{
                width:8,height:8,borderRadius:"50%",
                background:s.on?s.c:"#e2e8f0",
                boxShadow:s.on?`0 0 6px ${s.c}88`:"none"
              }}/>
              <span style={{fontSize:9,fontWeight:700,color:s.on?"#374151":"#94a3b8"}}>{s.id}</span>
            </div>
          ))}
          <div style={{flex:1}}/>
          <div style={{display:"flex",gap:4}}>
            <button onClick={()=>setRunning(true)} style={{
              padding:"3px 10px",border:"none",borderRadius:5,cursor:"pointer",
              fontSize:9,fontWeight:700,background:running?"#22c55e":"#f1f5f9",
              color:running?"white":"#64748b"}}>▶ Chạy</button>
            <button onClick={()=>setRunning(false)} style={{
              padding:"3px 10px",border:"none",borderRadius:5,cursor:"pointer",
              fontSize:9,fontWeight:700,background:!running?"#ef4444":"#f1f5f9",
              color:!running?"white":"#64748b"}}>■ Dừng</button>
          </div>
        </div>

        {/* ── Stand belt visual ── */}
        <div style={{
          background:"white",border:"1px solid #e2e8f0",borderRadius:8,
          padding:"10px 12px",marginBottom:10,
          boxShadow:"0 1px 3px rgba(0,0,0,0.04)"
        }}>
          <div style={{fontSize:11,fontWeight:700,color:"#64748b",
            letterSpacing:1,textTransform:"uppercase",marginBottom:10}}>
            Dây chuyền cán — {CT_STANDS.filter(s=>s.group==="rough").length} giá thô +{" "}
            {CT_STANDS.filter(s=>s.group==="finish").length} giá tinh
          </div>
          {/* Connecting pipe */}
          <div style={{height:4,background:"linear-gradient(90deg,#2563eb55,#22c55e55,#f59e0b55,#ef4444 55)",
            borderRadius:2,marginBottom:8}}/>
          {/* Stand grid */}
          <div style={{display:"flex",gap:6,flexWrap:"nowrap",overflowX:"auto",paddingBottom:4}}>
            {CT_STANDS.map((s,i)=>(
              <div key={s.id} style={{display:"flex",flexDirection:"column",alignItems:"center",gap:2,flexShrink:0}}>
                {/* Stand card compact */}
                <div
                  onClick={()=>setSelStand(prev=>prev?.id===s.id?null:s)}
                  style={{
                    background:selStand?.id===s.id?"#eff6ff":"white",
                    border:`2px solid ${selStand?.id===s.id?"#2563eb":s.alarm?"#fca5a5":"#e2e8f0"}`,
                    borderRadius:6,padding:"5px 4px",cursor:"pointer",textAlign:"center",
                    boxShadow:selStand?.id===s.id?"0 0 0 3px rgba(37,99,235,.15)":"none",
                    transition:"all .15s",width:44
                  }}>
                  <LoadBar pct={s.load} color={s.color} alarm={s.alarm} w={20} h={40}/>
                  <div style={{fontSize:8,fontWeight:800,marginTop:3,
                    color:selStand?.id===s.id?"#2563eb":s.alarm?"#ef4444":"#374151"}}>{s.id}</div>
                  <div style={{fontSize:7,fontFamily:"monospace",color:s.color,fontWeight:700}}>
                    {s.rpm}
                  </div>
                </div>
                {/* Group separator dot */}
                {i===1 && <div style={{
                  width:8,height:8,borderRadius:"50%",background:"#94a3b8",
                  marginTop:2,alignSelf:"center"
                }}/>}
              </div>
            ))}
          </div>
          <div style={{height:4,background:"linear-gradient(90deg,#ef4444 55,#f59e0b55,#22c55e55,#2563eb55)",
            borderRadius:2,marginTop:8}}/>
        </div>

        {/* ── Parameter table ── */}
        <div style={{
          background:"white",border:"1px solid #e2e8f0",borderRadius:8,
          padding:"10px 14px",marginBottom:10,
          boxShadow:"0 1px 3px rgba(0,0,0,0.04)"
        }}>
          <div style={{fontSize:10,fontWeight:700,color:"#374151",marginBottom:8}}>
            Bảng Thông Số Giá Cán
          </div>
          <div style={{overflowX:"auto"}}>
            <table style={{borderCollapse:"collapse",fontSize:9,width:"100%",minWidth:700}}>
              <thead>
                <tr style={{background:"#f8fafc",borderBottom:"2px solid #e2e8f0"}}>
                  <th style={{padding:"5px 8px",textAlign:"left",color:"#64748b",fontWeight:700,whiteSpace:"nowrap"}}>Thông số</th>
                  {CT_STANDS.map(s=>(
                    <th key={s.id} style={{padding:"5px 6px",textAlign:"center",
                      color:s.alarm?"#ef4444":s.color,fontWeight:800,
                      background:s.alarm?"#fef2f2":"transparent",whiteSpace:"nowrap"}}>
                      {s.id}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {[
                  {row:"Set tốc độ (rpm)", fn: s=>s.setRpm, color:"#64748b"},
                  {row:"Tốc độ TT (rpm)",  fn: s=>s.rpm,    color:"#2563eb", bold:true},
                  {row:"Tải (%)",          fn: s=>s.load,   color:"#f59e0b", bold:true},
                  {row:"Dòng điện (A)",    fn: s=>s.current??"—", color:"#0ea5e9"},
                  {row:"Set nước (L/min)", fn: s=>s.waterSet||"—", color:"#64748b"},
                  {row:"Nước TT (L/min)", fn: s=>s.water||"—", color:"#0ea5e9"},
                ].map(row=>(
                  <tr key={row.row} style={{borderBottom:"1px solid #f8fafc"}}
                    onMouseEnter={e=>e.currentTarget.style.background="#f8fafc"}
                    onMouseLeave={e=>e.currentTarget.style.background="white"}>
                    <td style={{padding:"5px 8px",color:"#64748b",whiteSpace:"nowrap",fontWeight:600}}>
                      {row.row}
                    </td>
                    {CT_STANDS.map(s=>{
                      const v = row.fn(s)
                      const isAlarm = s.alarm
                      return (
                        <td key={s.id} style={{
                          padding:"4px 6px",textAlign:"center",
                          fontFamily:"monospace",fontWeight:row.bold?700:400,
                          color:isAlarm?"#ef4444":row.color,
                          background:isAlarm?"#fef2f2":"transparent"
                        }}>{v}</td>
                      )
                    })}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        {/* ── Trend chart ── */}
        <div style={{
          background:"white",border:"1px solid #e2e8f0",borderRadius:8,
          padding:"10px 14px",
          boxShadow:"0 1px 3px rgba(0,0,0,0.04)"
        }}>
          <div style={{
            display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:8
          }}>
            <div style={{fontSize:10,fontWeight:700,color:"#374151"}}>
              Trend Tốc Độ Cán — 15 phút gần nhất
            </div>
            <div style={{display:"flex",gap:4}}>
              {["rpm","load","current"].map(m=>(
                <button key={m} onClick={()=>setTrendMode(m)} style={{
                  padding:"3px 8px",border:"none",borderRadius:4,cursor:"pointer",
                  fontSize:9,fontWeight:600,
                  background:trendMode===m?"#2563eb":"#f1f5f9",
                  color:trendMode===m?"white":"#64748b"
                }}>{m}</button>
              ))}
            </div>
          </div>
          {/* Legend */}
          <div style={{display:"flex",gap:8,flexWrap:"wrap",marginBottom:6}}>
            {CT_STANDS.map(s=>(
              <div key={s.id} style={{display:"flex",alignItems:"center",gap:3,cursor:"pointer"}}
                onClick={()=>setSelStand(prev=>prev?.id===s.id?null:s)}>
                <div style={{width:16,height:2.5,background:s.color,borderRadius:2,
                  opacity:selStand&&selStand.id!==s.id?0.3:1}}/>
                <span style={{fontSize:8,color:selStand?.id===s.id?s.color:"#64748b",
                  fontWeight:selStand?.id===s.id?700:400}}>{s.id}</span>
              </div>
            ))}
          </div>
          <MultiTrendChart
            series={CT_TRENDS
              .filter(t=>!selStand || t.id===selStand.id)
              .map(t=>({
                id:t.id, color:t.color,
                data:trendMode==="rpm"?t.rpmData:trendMode==="load"?t.loadData:t.currentData
              }))}
            height={150}
          />
        </div>


      </div>

      {/* ── Right detail panel 268px ── */}
      <div style={{
        width:268,background:"white",borderLeft:"1px solid #e2e8f0",
        flexShrink:0,overflowY:"auto"
      }}>
        <DetailPanel/>
      </div>
    </div>
  )
}

import { useState } from "react"

// ─── PX Cán Thép — Dây chuyền Cán Thép ───────────────────

const STATUS_STYLES = {
  running: { bg:"#dcfce7", color:"#16a34a", label:"Đang chạy" },
  stopped: { bg:"#fee2e2", color:"#dc2626", label:"Dừng"      },
  open:    { bg:"#dbeafe", color:"#2563eb", label:"Mở"        },
  ok:      { bg:"#f1f5f9", color:"#64748b", label:"OK"        },
}

const PXCT_DATA = [
  // Lò nung phôi
  { id:"CT.LN.LNN",   name:"Lò nung phôi thép (bước dầm)",          type:"Lò",           qty:1, since:"09/2016", status:"running", alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"CT.LN.QDLN",  name:"Quạt đốt lò nung (burner fan)",         type:"Máy",          qty:4, since:"09/2016", status:"running", alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"CT.LN.BNCLN", name:"Bơm nước làm mát bước dầm lò nung",    type:"Bơm",          qty:2, since:"09/2016", status:"ok",      alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"CT.LN.MSDP",  name:"Máy sấy dầu phun lò nung",             type:"Máy",          qty:1, since:"09/2016", status:"ok",      alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"CT.LN.PLCLN", name:"PLC điều khiển lò nung",                type:"Điện",         qty:1, since:"09/2016", status:"ok",      alarm:false, lastSeen:"12/03/2026 08:00" },
  // Cán thô
  { id:"CT.CTH.GR1",  name:"Giá cán thô số 1 (Ø 600mm)",           type:"Máy cán",      qty:1, since:"09/2016", status:"running", alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"CT.CTH.GR2",  name:"Giá cán thô số 2 (Ø 600mm)",           type:"Máy cán",      qty:1, since:"09/2016", status:"running", alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"CT.CTH.GR3",  name:"Giá cán thô số 3 (Ø 550mm)",           type:"Máy cán",      qty:1, since:"09/2016", status:"running", alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"CT.CTH.MD1",  name:"Mô tơ cán thô số 1 (800kW)",           type:"Điện",         qty:1, since:"09/2016", status:"running", alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"CT.CTH.MD2",  name:"Mô tơ cán thô số 2 (800kW)",           type:"Điện",         qty:1, since:"09/2016", status:"running", alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"CT.CTH.MD3",  name:"Mô tơ cán thô số 3 (630kW)",           type:"Điện",         qty:1, since:"09/2016", status:"running", alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"CT.CTH.HNP",  name:"Hộp số giảm tốc cán thô",              type:"Cơ khí",       qty:3, since:"09/2016", status:"ok",      alarm:false, lastSeen:"12/03/2026 08:00" },
  // Cán trung
  { id:"CT.CTR.GR4",  name:"Giá cán trung số 4 (Ø 450mm)",         type:"Máy cán",      qty:1, since:"09/2016", status:"running", alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"CT.CTR.GR5",  name:"Giá cán trung số 5 (Ø 450mm)",         type:"Máy cán",      qty:1, since:"09/2016", status:"running", alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"CT.CTR.GR6",  name:"Giá cán trung số 6 (Ø 400mm)",         type:"Máy cán",      qty:1, since:"09/2016", status:"running", alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"CT.CTR.MD4",  name:"Mô tơ cán trung số 4 (500kW)",         type:"Điện",         qty:1, since:"09/2016", status:"running", alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"CT.CTR.MD5",  name:"Mô tơ cán trung số 5 (500kW)",         type:"Điện",         qty:1, since:"09/2016", status:"running", alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"CT.CTR.MD6",  name:"Mô tơ cán trung số 6 (400kW)",         type:"Điện",         qty:1, since:"09/2016", status:"ok",      alarm:true,  lastSeen:"12/03/2026 07:20" },
  // Cán tinh
  { id:"CT.CTI.GR7",  name:"Giá cán tinh số 7 (Ø 350mm)",          type:"Máy cán",      qty:1, since:"09/2016", status:"running", alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"CT.CTI.GR8",  name:"Giá cán tinh số 8 (Ø 350mm)",          type:"Máy cán",      qty:1, since:"09/2016", status:"running", alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"CT.CTI.GR9",  name:"Giá cán tinh số 9 (Ø 300mm)",          type:"Máy cán",      qty:1, since:"09/2016", status:"running", alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"CT.CTI.GR10", name:"Giá cán tinh số 10 (Ø 300mm)",         type:"Máy cán",      qty:1, since:"09/2016", status:"running", alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"CT.CTI.MD7",  name:"Mô tơ cán tinh số 7–10 (250kW×4)",     type:"Điện",         qty:4, since:"09/2016", status:"running", alarm:false, lastSeen:"12/03/2026 08:00" },
  // Làm nguội & thu gom
  { id:"CT.LNG.SLN",  name:"Sàn làm nguội (cooling bed) 72m",       type:"Cơ khí",       qty:1, since:"09/2016", status:"running", alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"CT.LNG.MCCT", name:"Máy cắt nguội đầu cuối thanh",          type:"Máy",          qty:2, since:"09/2016", status:"ok",      alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"CT.LNG.MCHT", name:"Máy cắt hơi thanh phân đoạn",           type:"Máy",          qty:1, since:"09/2016", status:"running", alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"CT.LNG.MDBP", name:"Máy đóng bó phôi thanh tự động",       type:"Máy",          qty:2, since:"09/2016", status:"ok",      alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"CT.LNG.BTCT", name:"Băng tải thanh cán ra kho",             type:"Băng tải",     qty:3, since:"09/2016", status:"ok",      alarm:false, lastSeen:"12/03/2026 08:00" },
  // Hệ thống nước cán
  { id:"CT.NC.BNNC",  name:"Bơm nước cán (high pressure 200bar)",   type:"Bơm",          qty:2, since:"09/2016", status:"running", alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"CT.NC.BNTH",  name:"Bơm nước tuần hoàn làm mát trục cán",  type:"Bơm",          qty:4, since:"09/2016", status:"ok",      alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"CT.NC.TLNC",  name:"Tháp làm nguội nước cán",               type:"Khác",         qty:2, since:"09/2016", status:"ok",      alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"CT.NC.LBNC",  name:"Lọc nước cán (vảy sắt + dầu)",         type:"Khác",         qty:1, since:"09/2016", status:"ok",      alarm:false, lastSeen:"12/03/2026 08:00" },
  // Khí thải & lọc bụi
  { id:"CT.LD.LBCT",  name:"Lọc bụi túi vải xưởng cán",            type:"Khác",         qty:1, since:"09/2016", status:"running", alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"CT.LD.QGTL",  name:"Quạt gió thoát khói lò nung",           type:"Máy",          qty:2, since:"09/2016", status:"running", alarm:false, lastSeen:"12/03/2026 08:00" },
  // Điện & điều khiển
  { id:"CT.DK.MBT",   name:"Máy biến tần truyền động cán (VFD)",    type:"Điện",         qty:10,since:"09/2016", status:"ok",      alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"CT.DK.PLCCT", name:"PLC điều khiển dây chuyền cán",         type:"Điện",         qty:1, since:"09/2016", status:"ok",      alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"CT.DK.HMI",   name:"HMI vận hành xưởng cán",                type:"Điện",         qty:3, since:"09/2016", status:"ok",      alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"CT.DK.04KV",  name:"Hệ thống điện 0,4kV xưởng cán",        type:"Điện",         qty:1, since:"09/2016", status:"ok",      alarm:false, lastSeen:"12/03/2026 08:00" },
  { id:"CT.DK.SCADA", name:"Hệ thống SCADA xưởng cán thép",         type:"Điện",         qty:1, since:"09/2016", status:"running", alarm:false, lastSeen:"12/03/2026 08:00" },
]

function PXCTPanel() {
  const [pxctSubTab,   setPxctSubTab]   = useState("Dây Chuyền Cán Thép")
  const [search,       setSearch]       = useState("")
  const [filterType,   setFilterType]   = useState("Tous")
  const [alarmOnly,    setAlarmOnly]    = useState(false)
  const [viewMode,     setViewMode]     = useState("table")
  const [selectedItem, setSelectedItem] = useState(null)

  const types   = ["Tous", ...Array.from(new Set(PXCT_DATA.map(d=>d.type)))]
  const filtered = PXCT_DATA.filter(d => {
    if (alarmOnly && !d.alarm) return false
    if (filterType !== "Tous" && d.type !== filterType) return false
    if (search && !d.name.toLowerCase().includes(search.toLowerCase()) &&
                  !d.id.toLowerCase().includes(search.toLowerCase())) return false
    return true
  })

  return (
    <div style={{flex:1,display:"flex",flexDirection:"column",overflow:"hidden",background:"#f8fafc"}}>

      {/* Tab bar */}
      <div style={{
        background:"white",borderBottom:"1px solid #e2e8f0",
        padding:"0 16px",display:"flex",alignItems:"center",gap:4,flexShrink:0
      }}>
        {["Thiết bị","Dây Chuyền Cán Thép","Vận Hành CN"].map(t=>(
          <button key={t} onClick={()=>setPxctSubTab(t)} style={{
            padding:"10px 16px",border:"none",cursor:"pointer",fontSize:12,fontWeight:500,
            background:"transparent",
            color:pxctSubTab===t?"#1e3a5f":"#64748b",
            borderBottom:pxctSubTab===t?"2px solid #1e3a5f":"2px solid transparent",
            transition:"all .15s",whiteSpace:"nowrap"
          }}>{t}</button>
        ))}
      </div>

      {pxctSubTab==="Dây Chuyền Cán Thép" ? <DayChuyenCanThepView/> : pxctSubTab==="Vận Hành CN" ? <VanHanhCNView/> : (
      <>
      {/* Toolbar */}
      <div style={{
        background:"white",borderBottom:"1px solid #e2e8f0",
        padding:"10px 16px",display:"flex",alignItems:"center",gap:10,flexShrink:0,flexWrap:"wrap"
      }}>
        <div style={{
          display:"flex",alignItems:"center",gap:6,background:"#f8fafc",
          border:"1px solid #e2e8f0",borderRadius:6,padding:"5px 10px",minWidth:180
        }}>
          <span style={{color:"#94a3b8",fontSize:13}}>🔍</span>
          <input value={search} onChange={e=>setSearch(e.target.value)}
            placeholder="Tìm kiếm..."
            style={{border:"none",outline:"none",background:"transparent",fontSize:12,color:"#374151",width:140}}/>
        </div>
        <div style={{display:"flex",gap:4,flexWrap:"wrap"}}>
          {types.map(t=>(
            <button key={t} onClick={()=>setFilterType(t)} style={{
              padding:"4px 10px",border:"none",borderRadius:12,cursor:"pointer",fontSize:11,fontWeight:500,
              background:filterType===t?"#2563eb":"#f1f5f9",
              color:filterType===t?"white":"#64748b",transition:"all .15s"
            }}>{t}</button>
          ))}
        </div>
        <button onClick={()=>setAlarmOnly(p=>!p)} style={{
          padding:"4px 10px",border:`1px solid ${alarmOnly?"#ef4444":"#e2e8f0"}`,
          borderRadius:12,cursor:"pointer",fontSize:11,fontWeight:500,
          background:alarmOnly?"#fee2e2":"white",
          color:alarmOnly?"#ef4444":"#64748b",transition:"all .15s"
        }}>⚠ Chỉ cảnh báo</button>
        <div style={{flex:1}}/>
        <span style={{fontSize:11,color:"#94a3b8"}}>{filtered.length} thiết bị</span>
        <div style={{display:"flex",gap:2}}>
          {["table","grid"].map(m=>(
            <button key={m} onClick={()=>setViewMode(m)} style={{
              padding:"5px 8px",border:"none",borderRadius:5,cursor:"pointer",
              background:viewMode===m?"#2563eb":"#f1f5f9",
              color:viewMode===m?"white":"#64748b",fontSize:13,transition:"all .15s"
            }}>{m==="table"?"≡":"⊞"}</button>
          ))}
        </div>
      </div>

      {/* Content + detail */}
      <div style={{flex:1,display:"flex",overflow:"hidden"}}>

        <div style={{flex:1,overflow:"auto"}}>
          {viewMode==="table" ? (
            <table style={{width:"100%",borderCollapse:"collapse",fontSize:12}}>
              <thead>
                <tr style={{background:"#f8fafc",borderBottom:"2px solid #e2e8f0"}}>
                  {["ID","Tên thiết bị","Loại","SL","Ngày SD","Trạng thái","Cảnh báo"].map(h=>(
                    <th key={h} style={{padding:"8px 12px",textAlign:"left",fontWeight:600,
                      color:"#64748b",fontSize:11,whiteSpace:"nowrap"}}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {filtered.map(item=>{
                  const ss  = STATUS_STYLES[item.status]||STATUS_STYLES.ok
                  const sel = selectedItem?.id===item.id
                  return (
                    <tr key={item.id}
                      onClick={()=>setSelectedItem(p=>p?.id===item.id?null:item)}
                      style={{
                        background:sel?"#eff6ff":item.alarm?"#fff7f7":"white",
                        borderBottom:"1px solid #f1f5f9",cursor:"pointer",transition:"background .1s"
                      }}>
                      <td style={{padding:"8px 12px",fontFamily:"monospace",color:"#64748b",fontSize:11}}>{item.id}</td>
                      <td style={{padding:"8px 12px",fontWeight:600,color:"#0f172a",maxWidth:280}}>{item.name}</td>
                      <td style={{padding:"8px 12px",color:"#64748b",whiteSpace:"nowrap"}}>{item.type}</td>
                      <td style={{padding:"8px 12px",textAlign:"center",fontWeight:700,color:"#374151"}}>{item.qty}</td>
                      <td style={{padding:"8px 12px",color:"#64748b",whiteSpace:"nowrap",fontSize:11}}>{item.since}</td>
                      <td style={{padding:"8px 12px"}}>
                        <span style={{background:ss.bg,color:ss.color,padding:"2px 8px",
                          borderRadius:8,fontSize:10,fontWeight:600}}>{ss.label}</span>
                      </td>
                      <td style={{padding:"8px 12px",textAlign:"center"}}>
                        {item.alarm
                          ? <span style={{width:18,height:18,borderRadius:"50%",background:"#ef4444",
                              display:"inline-flex",alignItems:"center",justifyContent:"center",
                              fontSize:9,color:"white",fontWeight:900}}>!</span>
                          : <span style={{color:"#22c55e",fontSize:14}}>✓</span>}
                      </td>
                    </tr>
                  )
                })}
              </tbody>
            </table>
          ) : (
            <div style={{
              display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(180px,1fr))",
              gap:10,padding:14
            }}>
              {filtered.map(item=>{
                const ss  = STATUS_STYLES[item.status]||STATUS_STYLES.ok
                const sel = selectedItem?.id===item.id
                return (
                  <div key={item.id}
                    onClick={()=>setSelectedItem(p=>p?.id===item.id?null:item)}
                    style={{
                      background:"white",borderRadius:8,padding:12,cursor:"pointer",
                      border:`2px solid ${sel?"#2563eb":item.alarm?"#fca5a5":"#e2e8f0"}`,
                      boxShadow:sel?"0 0 0 3px rgba(37,99,235,.12)":"0 1px 3px rgba(0,0,0,0.04)",
                      transition:"all .15s"
                    }}>
                    <div style={{fontSize:9,fontFamily:"monospace",color:"#94a3b8",marginBottom:4}}>{item.id}</div>
                    <div style={{fontSize:11,fontWeight:700,color:"#374151",marginBottom:8,lineHeight:1.3}}>{item.name}</div>
                    <div style={{fontSize:20,fontWeight:800,color:"#374151",lineHeight:1}}>
                      {item.qty} <span style={{fontSize:11,color:"#94a3b8",fontWeight:400}}>chiếc</span>
                    </div>
                    <div style={{fontSize:9,color:"#94a3b8",marginBottom:8}}>Sử dụng từ {item.since}</div>
                    <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                      <span style={{background:ss.bg,color:ss.color,padding:"2px 7px",
                        borderRadius:8,fontSize:9,fontWeight:600}}>{ss.label}</span>
                      {item.alarm&&<span style={{width:16,height:16,borderRadius:"50%",background:"#ef4444",
                        display:"inline-flex",alignItems:"center",justifyContent:"center",
                        fontSize:8,color:"white",fontWeight:900}}>!</span>}
                    </div>
                  </div>
                )
              })}
            </div>
          )}
        </div>

        {/* Detail panel */}
        <div style={{
          width:268,background:"white",borderLeft:"1px solid #e2e8f0",
          flexShrink:0,overflowY:"auto"
        }}>
          {!selectedItem ? (
            <div style={{height:"100%",display:"flex",flexDirection:"column",
              alignItems:"center",justifyContent:"center",
              color:"#94a3b8",fontSize:12,padding:20,textAlign:"center",gap:8}}>
              <span style={{fontSize:32}}>⚙</span>
              <span style={{fontWeight:600,color:"#64748b"}}>Chưa chọn đối tượng</span>
              <span style={{fontSize:11,color:"#cbd5e1",lineHeight:1.5}}>
                Nhấp vào một thiết bị để hiển thị thông tin
              </span>
            </div>
          ) : (()=>{
            const item = selectedItem
            const ss   = STATUS_STYLES[item.status]||STATUS_STYLES.ok
            const trend = Array.from({length:20},(_,i)=>
              20+Math.abs(Math.sin(i/3))*60+(Math.random()-.5)*10
            )
            return (
              <div>
                <div style={{padding:"10px 14px",background:"#f8fafc",
                  borderBottom:"1px solid #e2e8f0",
                  display:"flex",alignItems:"center",justifyContent:"space-between"}}>
                  <div>
                    <span style={{fontSize:9,color:"#94a3b8",fontFamily:"monospace"}}>{item.id} · </span>
                    <span style={{fontSize:12,fontWeight:700,color:"#0f172a"}}>{item.name}</span>
                  </div>
                  {item.alarm&&<span style={{width:18,height:18,borderRadius:"50%",background:"#ef4444",
                    display:"inline-flex",alignItems:"center",justifyContent:"center",
                    fontSize:9,color:"white",fontWeight:900}}>!</span>}
                </div>
                <div style={{display:"flex",borderBottom:"1px solid #f1f5f9"}}>
                  {["Thông tin","Lịch sử","Cảnh báo"].map((t,i)=>(
                    <button key={t} style={{padding:"8px 10px",border:"none",cursor:"pointer",fontSize:11,
                      fontWeight:i===0?700:400,color:i===0?"#2563eb":"#94a3b8",
                      borderBottom:i===0?"2px solid #2563eb":"2px solid transparent",
                      background:"none"}}>{t}</button>
                  ))}
                </div>
                <div style={{padding:"14px",display:"flex",alignItems:"center",
                  gap:10,background:"white",borderBottom:"1px solid #f1f5f9"}}>
                  <div style={{flex:1}}>
                    <div style={{fontSize:24,fontWeight:800,color:"#374151",lineHeight:1}}>
                      {item.qty} <span style={{fontSize:13,fontWeight:400,color:"#94a3b8"}}>chiếc</span>
                    </div>
                    <div style={{fontSize:11,color:"#94a3b8",marginTop:2}}>Sử dụng từ {item.since}</div>
                  </div>
                  <span style={{background:ss.bg,color:ss.color,padding:"3px 10px",
                    borderRadius:10,fontSize:10,fontWeight:600}}>{ss.label}</span>
                </div>
                {[
                  ["Mã máy",     item.id],
                  ["Loại",       item.type],
                  ["Số lượng",   `${item.qty} chiếc`],
                  ["Ngày SD",    item.since],
                  ["Trạng thái", ss.label],
                  ["Cảnh báo",   item.alarm?"Có":"Không"],
                ].map(([k,v])=>(
                  <div key={k} style={{display:"flex",justifyContent:"space-between",
                    padding:"7px 14px",borderBottom:"1px solid #f8fafc"}}>
                    <span style={{fontSize:11,color:"#94a3b8"}}>{k}</span>
                    <span style={{fontSize:11,fontWeight:600,
                      color:k==="Cảnh báo"&&item.alarm?"#ef4444":"#0f172a"}}>{v}</span>
                  </div>
                ))}
                <div style={{padding:"8px 14px 2px",fontSize:9,fontWeight:700,
                  color:"#94a3b8",letterSpacing:1,background:"#f8fafc",marginTop:4}}>GIỜ VỪA QUA</div>
                <div style={{padding:"6px 14px 14px",background:"#f8fafc"}}>
                  <div style={{display:"flex",alignItems:"flex-end",gap:1,height:52}}>
                    {trend.map((v,i)=>(
                      <div key={i} style={{flex:1,height:`${v}%`,
                        background:item.alarm?"#ef4444":"#22c55e",
                        borderRadius:"1px 1px 0 0",opacity:0.8}}/>
                    ))}
                  </div>
                  <div style={{display:"flex",justifyContent:"space-between",marginTop:3}}>
                    <span style={{fontSize:7,color:"#94a3b8"}}>-1h</span>
                    <span style={{fontSize:7,color:"#94a3b8"}}>hiện tại</span>
                  </div>
                </div>
              </div>
            )
          })()}
        </div>
      </div>
      </>
      )}
    </div>
  )
}

export default PXCTPanel
